import { z } from 'zod';

export const passwordValidation = z.string().trim().min(8);

export const accountValidation = z.object({
  name: z.string(),
  isDemoAccount: z.boolean().optional(),
});

export const registerValidation = z.object({
  email: z.string().email(),
  firstName: z.string(),
  lastName: z.string(),
  password: z.string(),
  service_id: z.string(),
});
